export const findCountry = (countryOptions, market) =>
	countryOptions.find((option) => option.value === market);
